import React, { Component } from "react";
import { showToast, TOAST_TYPE, DKButton, showLoader, removeLoader } from 'deskera-ui-library';
import TerminatioManager from "./EmployeeTerminateStepManager";
import Stepper from "../common/Stepper";
import { connect } from "react-redux";
import Table from "../../services/table";

class TerminateEmployee extends Component {

    constructor(props) {
        super(props)
        this.tableName = this.props.module;
        this.source = this.props.origin;
        this.steps = TerminatioManager.getAllCreationSteps(this.onSkipToStep);
        this.stepperWidth = 200;

        this.passedStep = this.props.step
        this.employeeId = this.props.id
        this.employeeData = this.props.employeeData.data.users
        this.state = {
            currentStep: parseInt(this.passedStep),
            isCurrentStepInvalid:false
        };
    }


    componentDidMount() {
        // RouteManager.setPresenter(this);
    }

    handleStepData = (data, callback) => {
        this.setState({ ...data }, callback);
    }

    getCurrentStepChild() {
        const currStep = this.steps[this.state.currentStep];
        return currStep.getChild({
            state: this.state,
            tableName: this.tableName,
            setData: this.handleStepData,
            employeeId: this.employeeId,
            ...this.props,
            checkValid: this.state.isCurrentStepInvalid
            // handleCallback: this.handleCallback()
        });
    }

    onSkipToStep = (event, index) => {
        const { currentStep } = this.state;

        if ((currentStep === 0 && this.checkFirstStepIsInValid())) {
            showToast(`Please fill all required field`, TOAST_TYPE.FAILURE);
            if(this.state.currentStep == 0) {
                this.setState(
                    {   currentStep: this.state.currentStep,
                        isCurrentStepInvalid:true})
            }
            return
        }


        /* By default expected step is to move forward */
        const expectedStep = index ?? currentStep + 1;

        /* If it's the last step */
        if (expectedStep === this.steps.length) {
            this.handleImportConfirmation();
            return;
        }

        this.setState({ currentStep: expectedStep });

    };

    checkFirstStepIsInValid() {
        const { detailObj } = this.state
        return detailObj.terminationDate.trim() === "" ? true : detailObj.terminationReason.trim() === "" ? true : detailObj.employeePersonalEmail.trim() === "" ? true : false
    };

    checkSecondStepIsInValid() {
        let isInvalid = false
        const { checkList } = this.state
        checkList.forEach(obj=>{
            if(obj.item.trim() === ""){
                isInvalid = true
            }
        })
        return isInvalid
    };



    onTerminate = () => {
        if (this.checkSecondStepIsInValid()) {
            showToast(`Please fill all required field`, TOAST_TYPE.FAILURE);
            return
        }
        this.isUpdated = false
        this.employeeData.forEach(user => {
            if (user.terminationStage === "termination_initiated" && user.userId === this.employeeId) {
                this.isUpdated = true
            }
        });

        showLoader("Terminating Employee...");
        if (!this.isUpdated) {
            Table.postTerminatedEmployee(this.state.detailObj).then(
                (response) => {
                    Table.postTerminatedCheckList(this.state.checkList, this.state.detailObj.employeeId).then(
                        (data) => {
                            removeLoader();
                            showToast("Emplpoyee Terminated Successfully", TOAST_TYPE.SUCCESS);
                            this.props.close(true);
                        }, (error) => {
                            removeLoader();
                            if (error?.errorMessage) {
                                showToast(error?.errorMessage, TOAST_TYPE.FAILURE);
                            } else {
                                showToast("Something went wrong. Please try after sometime.", TOAST_TYPE.FAILURE);
                            }
                        }
                    );
                }, (error) => {
                    removeLoader();
                    if (error?.errorMessage) {
                        showToast(error?.errorMessage, TOAST_TYPE.FAILURE);
                    } else {
                        showToast("Something went wrong. Please try after sometime.", TOAST_TYPE.FAILURE);
                    }
                }
            );
        } else {
            Table.putTerminatedEmployee(this.state.detailObj).then(
                (response) => {
                    Table.patchTerminatedCheckList(this.state.checkList, this.state.detailObj.employeeId).then(
                        (data) => {
                            removeLoader();
                            showToast("Emplpoyee Terminated Successfully", TOAST_TYPE.SUCCESS);
                            this.props.close(true);
                        }, (error) => {
                            removeLoader();
                            if (error?.errorMessage) {
                                showToast(error?.errorMessage, TOAST_TYPE.FAILURE);
                            } else {
                                showToast("Something went wrong. Please try after sometime.", TOAST_TYPE.FAILURE);
                            }
                        }
                    );
                }, (error) => {
                    removeLoader();
                    if (error?.errorMessage) {
                        showToast(error?.errorMessage, TOAST_TYPE.FAILURE);
                    } else {
                        showToast("Something went wrong. Please try after sometime.", TOAST_TYPE.FAILURE);
                    }
                }
            );
        }
    }


    getControllers() {
        const { fileInfo, currentStep } = this.state;
        const isLastStep = currentStep === this.steps.length - 1;
        return (
            <div className="row parent-width justify-content-start">
                <DKButton
                    title="Cancel"
                    className="border-m bg-gray1"
                    onClick={() =>
                        this.props.close(false)
                    }
                />
                {currentStep == 0 && (
                    <DKButton
                        title="Save and Next"
                        className="border-m ml-m bg-button text-white bg-app"
                        onClick={this.onSkipToStep}
                    />
                )}
                {currentStep == 1 && (
                    <DKButton
                        title="Terminate"
                        className="border-m ml-m bg-button text-white bg-app"
                        onClick={this.onTerminate}
                    />
                )}
            </div>
        );
    }
    render() {
        return (
            <div className="transparent-background">
                <div className="popup-window" >
                    <div className="parent-width custom-scroll" style={{     overflowX: 'hidden', overflowY: 'auto' }}>
                        <div className="column parent-width p-s">
                            <div className="row mb-r"><h2 style={{ marginTop: 0 }}><b>Terminate Employee</b></h2></div>
                            <Stepper
                                data={this.steps}
                                currentIndex={this.state.currentStep}
                                className="mb-l"
                                stepperType="TERMINATION"
                                width={this.stepperWidth}
                            />

                            <div className="row parent-width">
                                {this.getCurrentStepChild()}
                            </div>

                            {this.getControllers()}
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return { employeeData: state.employee }
}

export default connect(mapStateToProps)(TerminateEmployee);

// export default TerminateEmployee